<template>
  <div class="textSecondary--text mr-2 body-2">
    <div class="fixed-width">
      <RideInfoLine
        v-if="ridePrice"
        :label="$t('trips.ridePrice')"
        :value="`€ ${formatMoney(ridePrice)}`"
      />
      <RideInfoLine
        v-if="featurePrice"
        :label="$t('trips.featuresPrice')"
        :value="`€ ${formatMoney(featurePrice)}`"
      />
    </div>
    <div
      v-if="
        appConfig.isNightCardsSupport &&
        !!trip.nightRiderCards &&
        !!trip.nightRiderCards.length
      "
      class="mb-2"
    >
      <hr class="mt-4" />
      <div class="mb-2">
        <span class="mr-2">{{ $t("nightRider.tripNightCards") }}</span>
      </div>
      <VChip
        v-for="(card, index) in trip.nightRiderCards"
        :key="index"
        small
        class="mr-2"
      >
        <VIcon left> mdi-ticket </VIcon>
        {{ card }}
      </VChip>
    </div>
    <template v-if="trip.bookingPrice">
      <div
        class="
          total-price
          fixed-width
          d-flex
          justify-space-between
          flex-wrap
          textPrimary--text
          heading-6
          py-1
        "
      >
        <span class="mr-2 body bold">{{ $t("trips.totalPrice") }}</span>
        <span class="body bold">€ {{ formatMoney(trip.bookingPrice) }}</span>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Price',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import moment from 'moment';
import SConstants from '@slg/web-customer-shared/src/utils/constants';
import { getTranslateByStringMap } from '@slg/web-customer-shared/src/utils/translationHelper';
import RideInfoLine from '@slg/web-customer-shared/src/components/common/ride/RideInfoLine.vue';
import { useI18n } from '../../../../composables';

const props = defineProps({
  trip: {
    type: Object,
    required: true,
  },
  appConfig: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const tripType = computed(() => (props.trip.privateShuttle
  ? t('trips.private')
  : t('trips.shared')));

const featurePrice = computed(() => (props.trip?.selectedFeatures || []).reduce((acc: number, feature: { price: number; capacity: number }) => {
  acc += +feature.price * feature.capacity;
  return acc;
}, 0));

const ridePrice = computed(() => Number(props.trip.bookingPrice - featurePrice.value));

const vehicleCategory = computed(() => getTranslateByStringMap(props.trip.vehicleCategoryName));

const returnTrip = computed(() => (
  props.trip.returnTripDateTime &&
  moment(props.trip.returnTripDateTime).format(
    SConstants.TIME_FORMAT.MMM_DD
  )
));

function formatMoney(value: number) {
  return Number(value || 0).toFixed(2);
}
</script>

<style scoped>
.fixed-width {
  width: 218px;
}

.total-price {
  border-top: 1px solid var(--v-grey-lighten1);
  border-bottom: 1px solid var(--v-grey-lighten1);
}
</style>
